import Vue from "vue";

import { Beautify } from "./beautify";
import { ModelPhone } from "./modelPhone";
import { AutoExpand } from "./autoexpand";
import { Units } from "./units";

Vue.directive('beautify', Beautify);
Vue.directive('model-phone', ModelPhone);
Vue.directive('autoexpand', AutoExpand);
Vue.directive('units', Units);
